import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
//UI
import PublicLayout from '../../../layouts/PublicLayout';
import { getPoliticsThunk } from '../../../store/slices/catalogs/politics.slice';
import MainLoader from '../../../components/Loaders/MainLoader';
import { aceptarPoliticaThunk, getAceptacionPoliticaThunk } from '../../../store/slices/public/aceptacionPoliticas.slice';
import { FaCheckCircle } from 'react-icons/fa';

const PrivacyPolitics = () => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { items } = useSelector(state => state.politics);
    const aceptacion = useSelector(state => state.aceptacion_politicas)
    const isLoading = useSelector(state => state.isLoadingSlice);
    const user = JSON.parse(localStorage.getItem("userInfo"));

    useEffect(() => {
        dispatch(getPoliticsThunk());
        dispatch(getAceptacionPoliticaThunk(user.id))
    }, []);

    const [accepted, setAccepted] = useState(false);

    const handleAccept = () => {
        if (accepted) {
            dispatch(aceptarPoliticaThunk(user.id));
        }
    };

    if (aceptacion.message === "Registro actualizado correctamente ") {
        dispatch(getAceptacionPoliticaThunk(user.id))
    }

    return (
        <PublicLayout>
            {isLoading ? (
                <MainLoader />
            ) : (
                <div className="w-full px-10 py-8">
                    <div className="bg-white h-full shadow-md rounded-xl p-8 w-full mx-auto border border-gray-200">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6">{items[0]?.name}</h2>
                        <div className="text-start h-[356px] overflow-y-auto border border-gray-100 rounded-lg p-4 text-sm text-gray-700 bg-gray-50 space-y-3 mb-6">
                            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(items[0]?.content) }}></p>
                        </div>
                        {
                            !aceptacion.item.isAcept ?
                                <>
                                    <div className="flex items-start mb-6">
                                        <input
                                            type="checkbox"
                                            id="accept"
                                            className="mt-1 mr-3"
                                            checked={accepted}
                                            onChange={() => setAccepted(!accepted)}
                                        />
                                        <label htmlFor="accept" className="text-sm text-gray-700">
                                            Declaro que he leído y acepto la política de privacidad del Colegio.
                                        </label>
                                    </div>
                                    <button
                                        className={`w-full py-2 px-4 rounded-md text-white font-semibold transition ${accepted ? 'bg-p-sky/70 hover:bg-p-sky' : 'bg-gray-300 cursor-not-allowed'
                                            }`}
                                        disabled={!accepted}
                                        onClick={handleAccept}
                                    >
                                        Aceptar y continuar
                                    </button>
                                </>
                                :
                                <div className='flex items-center justify-center gap-5 text-p-green'>
                                    <FaCheckCircle size={50} />
                                    <div className='flex flex-col text-start'>
                                        <h2 className='text-xl font-semibold'>Proceso completado</h2>
                                        <p className='text-p-blue'>Muchas gracias por su tiempo. ya puede iniciar el proceso de matriculación</p>
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            )}
        </PublicLayout>
    );
};

export default PrivacyPolitics;